// ============================================================================
// Z ALGORITHM - ALGORITHM METADATA
// ============================================================================

export const meta = {
  id: 'z-algorithm',
  name: 'Z Algorithm',
  category: 'Strings',
  complexity: {
    time: 'O(N)',
    space: 'O(N)'
  },
  description: 'A linear-time algorithm for pattern matching that computes the Z-array, where Z[i] is the length of the longest substring starting at position i that matches the prefix of the string.'
};
